import { Mail, Phone } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { PortalBranding } from "@/features/portal/types";

/** Introduction tab — welcome copy, notes, and a firm contact card. Next only. */
export function IntroductionTab({ branding }: { branding: PortalBranding | null }) {
  const firmName = branding?.firmName || "your tax professional";
  return (
    <div className="grid gap-6">
      <div className="grid gap-3">
        <h2 className="font-heading text-foreground text-2xl font-bold">
          Welcome{branding?.firmName ? ` to ${branding.firmName}` : ""}
        </h2>
        <p className="text-muted-foreground text-sm leading-relaxed">
          {firmName} has invited you to complete your profile. This short form
          collects the identity, contact, and address details we need to prepare
          your case. It takes just a few minutes.
        </p>
      </div>

      <Card className="bg-muted/40">
        <CardHeader>
          <CardTitle className="text-base">Before you begin</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="text-muted-foreground list-disc space-y-2 pl-4 text-sm">
            <li>Your answers save automatically as you move between fields.</li>
            <li>You can move between tabs using the tabs above or Previous / Next.</li>
            <li>
              Have your identification handy (SSN or EIN, driver&apos;s license,
              and address information).
            </li>
            <li>On the last tab, review your details and click Finish to submit.</li>
          </ul>
        </CardContent>
      </Card>

      {(branding?.phone || branding?.email) && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Need help?</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-2 text-sm">
            <p className="text-muted-foreground">
              Contact {branding?.firmName || "our office"} if you have any questions.
            </p>
            {branding?.phone && (
              <p className="flex items-center gap-2">
                <Phone className="text-muted-foreground size-4" />
                {branding.phone}
              </p>
            )}
            {branding?.email && (
              <p className="flex items-center gap-2">
                <Mail className="text-muted-foreground size-4" />
                {branding.email}
              </p>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
